import React from "react";
import { useSelectedReport } from "../../hooks/useSelectedReport";
import { ProgressReportForm } from "./reports/ProgressReportForm";
import { IdentifierReportForm } from "./reports/IdentifierReportForm";
import { PiidReportForm } from "./reports/PiidReportForm";
import { WipoReportForm } from "./reports/WipoReportForm";
import { NiposReportForm } from "./reports/NiposReportForm";
import { AnnualReportForm } from "./reports/AnnualReportForm";
import { ScknReportForm } from "./reports/ScknReportForm";
import { Kult1501ReportForm } from "./reports/Kult1501ReportForm";
import { IpaReportForm } from "./reports/IpaReportForm";
import { OnixExportForm } from "./reports/OnixExportForm";
import { PerformanceStatisticsReportForm } from "./reports/PerformanceStatisticsReportForm";
export var OutputsReportForm = function () {
    var selectedReportKey = useSelectedReport().selectedReportKey;
    switch (selectedReportKey) {
        case "progress-report":
            return React.createElement(ProgressReportForm, null);
        case "identifier-report":
            return React.createElement(IdentifierReportForm, null);
        case "piid-report":
            return React.createElement(PiidReportForm, null);
        case "wipo-report":
            return React.createElement(WipoReportForm, null);
        case "nipos-report":
            return React.createElement(NiposReportForm, null);
        case "annual-report":
            return React.createElement(AnnualReportForm, null);
        case "sckn-report":
            return React.createElement(ScknReportForm, null);
        case "kult-15-01":
            return React.createElement(Kult1501ReportForm, null);
        case "ipa-report":
            return React.createElement(IpaReportForm, null);
        case "onix-export":
            return React.createElement(OnixExportForm, null);
        case "performance-statistics":
            return React.createElement(PerformanceStatisticsReportForm, null);
        default:
            return null;
    }
};
